const validateDomain = value => {
  if (!value) {
    return {
      isValid: false,
      message: 'Input cannot be empty.'
    }
  }

  if (!/^[a-z0-9-]+$/.test(value)) {
    return {
      isValid: false,
      message: 'Only lowercase letters, numbers, and hyphens are allowed.'
    }
  }

  if (!/^[a-z0-9].*[a-z0-9]$/.test(value)) {
    return {
      isValid: false,
      message: 'The string must start and end with a letter or number.'
    }
  }

  if (/--/.test(value)) {
    return {
      isValid: false,
      message: 'The string cannot contain consecutive hyphens (--).'
    }
  }

  return {
    isValid: true,
    message: 'Valid string.'
  }
}

export default validateDomain
